import { ExperienceFlagIds, ExperienceFlagsConfig } from '@hcs/types';

export const EXPERIENCE_FLAG_CONFIGS: {
  [key in ExperienceFlagIds]: ExperienceFlagsConfig;
} = {
  PEXP_REDESIGN: {
    experienceFlagId: 'PEXP_REDESIGN',
    displayName: 'PEXP 2.0',
    description: 'PEXP users see the redesigned PEXP 2.0 experience.',
    jiraTickets: ['EXP-324'],
    figmaLinks: {
      prototype:
        'https://www.figma.com/proto/pdQZ14kLbLD686nsMIKJgd/2021-PEXP---Tier-3?node-id=811%3A35788&scaling=min-zoom&page-id=811%3A35788&starting-point-node-id=3614%3A141421&show-proto-sidebar=1',
      inspect:
        'https://www.figma.com/file/pdQZ14kLbLD686nsMIKJgd/2021-PEXP---Tier-3?node-id=811%3A35788&t=xQvQnKN2YfFtWLBe-0',
    },
    envs: {
      dev: true,
      stage: true,
      prod: true,
    },
  },
  PORTFOLIO_DEXP: {
    experienceFlagId: 'PORTFOLIO_DEXP',
    displayName: 'Portfolio DEXP',
    description:
      'Portfolio Monitor users can purchase a DEXP analysis for a portfolio.',
    jiraTickets: ['SPLAT-1720'],
    figmaLinks: {
      prototype: 'https://fiber-number-86659427.figma.site/',
    },
    envs: {
      dev: false,
      stage: false,
      prod: false,
    },
  },
  DEVELOPER_CENTER: {
    experienceFlagId: 'DEVELOPER_CENTER',
    displayName: 'Developer Center',
    description: 'Developer tools and resources.',
    jiraTickets: ['SPLAT-1743'],
    envs: {
      dev: false,
      stage: false,
      prod: false,
    },
  },
};
